



















import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class OrderDetails extends Vue {
  @Prop({ required: true }) private readonly merchantName!: string;

  @Prop({ required: true }) private readonly orderId!: string;

  @Prop({ required: true }) private readonly pickupTime!: string;

  @Prop({ required: true }) private readonly timezone!: string;

  private get zonedPickupDate(): moment.Moment {
    return moment(this.pickupTime).tz(this.timezone);
  }

  private get time(): string {
    return this.zonedPickupDate.format('hh:mm a');
  }

  private get date(): string {
    return this.zonedPickupDate.format('ddd, MMM D');
  }
}

